import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-left">
        <span className="badge">SHAPING A BETTER TOMORROW</span>

        <h1>
          Creating Impact <br /> That Never Fades
        </h1>

        <p>
          We empower people, communities, and ideas, helping them build
          solutions that outlive us all.
        </p>

        <button className="cta">
          Get Involved
          <span>→</span>
        </button>
      </div>

      <div className="hero-right">
        <img
          src="images/conference.jpg"
          alt="volunteers"
        />
      </div>
    </section>
  );
};

export default Hero;